import { List, OrderedMap } from 'immutable';

import { CLEANUP, Cleanup } from '../actions';
import {
  SET_LAST_TRIGGERED_TIME, SetLastTriggeredTime,
  SETUP_CONFLICT, SetupConflict,
} from '../actions/conflict';
import {
  CANCEL_INSERT, CancelInsert,
  INSERT_IN_BET_SLIP, INSERT_IN_QUEUE_FOR_DELETE, InsertInBetSlip,
  InsertInQueueForAdd,
  InsertInQueueForDelete,
  REPLACE_ENTRIES, ReplaceEntries,
} from '../actions/entries';
import { Conflict, RecordOfConflict } from '../records';
import { ConflictState } from '../types/conflict';

// ---

export type ConflictActions =
  | SetupConflict
  | InsertInQueueForDelete
  | InsertInBetSlip
  | ReplaceEntries
  | CancelInsert
  | Cleanup
  | SetLastTriggeredTime;

type InsertInQueueForAddPayload = InsertInQueueForAdd['payload'];

function createConflict(payload: SetupConflict['payload']): RecordOfConflict {
  const {
    entries = [],
    highlightEntryIds,
    actions,
  } = payload;

  return Conflict({
    case: payload.case,
    highlightEntryIds,

    items: entries.reduce((map, entry) => {
      return map.set(entry.bet.entity.id, entry);
    }, OrderedMap<number, InsertInQueueForAddPayload>()),

    actions: List(actions),
  });
}

function insertInQueueForDelete(
  state: ConflictState,
  payload: InsertInQueueForDelete['payload'],
): ConflictState {
  if (!state) {
    return state;
  }

  let highlightEntryIds = state.get('highlightEntryIds');

  payload.entries.forEach(({ betId }) => {
    highlightEntryIds = highlightEntryIds.delete(betId);
  });

  return state.update('highlightEntryIds', () => highlightEntryIds);
}

function setLastTriggeredTime(
  state: ConflictState,
  payload: SetLastTriggeredTime['payload'],
) {
  if (!state) {
    return state;
  }
  return state.set('lastTriggeredTime', payload.lastTriggeredTime);
}

export default function (
  state: ConflictState = null,
  action: ConflictActions,
): ConflictState {
  switch (action.type) {
    case SETUP_CONFLICT:
      return createConflict(action.payload);

    case INSERT_IN_QUEUE_FOR_DELETE:
      return insertInQueueForDelete(state, action.payload);

    case SET_LAST_TRIGGERED_TIME:
      return setLastTriggeredTime(state, action.payload);

    case REPLACE_ENTRIES:
    case CANCEL_INSERT:
    case INSERT_IN_BET_SLIP:
    case CLEANUP:
      return null;

    default:
      return state;
  }
}
